import { render, staticRenderFns } from "./FormGroupedCourseSetSelect.vue?vue&type=template&id=38017f1e&"
import script from "./FormGroupedCourseSetSelect.vue?vue&type=script&lang=js&"
export * from "./FormGroupedCourseSetSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports